import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConverterService, OccEndpointsService, PRODUCT_NORMALIZER } from '@spartacus/core';
import { map, catchError, of } from 'rxjs';
import { KB_PRODUCT_URL_NORMALIZER } from 'src/app/app.module';

@Injectable({
  providedIn: 'root'
})
export class QuickOrderService {

  constructor(private http: HttpClient,
    private occService: OccEndpointsService,
    private converterService: ConverterService) { }


  getApi(cartId) {
    return this.http.get(this.occService.buildUrl(`getquickorder?cartId=${cartId}`));
  }
  getProductInfoApi(code) {
    return this.http.get(this.occService.buildUrl(`productinfo?code=${code}`));
  }
  getReqDelvDateApi(cartId) {
    return this.http.get(this.occService.buildUrl(`getrequesteddeliverydate?cartId=${cartId}`));
  }
  getOrderType(orderType, cartId) {
    return this.http.get(this.occService.buildUrl(`getordertype?orderType=${orderType}&cartId=${cartId}`))
  }
  postApi(file, orderType, cartId) {
    return this.http.post(this.occService.buildUrl(`addquickorder?orderType=${orderType}&cartId=${cartId}`),file).pipe(
      map((res: any) => {
        if (res.modifications) {
          res.modifications = res.modifications.map((modification) => {
            if (modification.entry) {
              modification.entry.product = this.converterService.convert(modification.entry.product, PRODUCT_NORMALIZER);
            }
            return modification;
          });
        }
        return res;
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }
}
